import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from 'react'

interface PseudolocContextValue {
  enabled: boolean
  toggle: () => void
}

const PseudolocContext = createContext<PseudolocContextValue | undefined>(undefined)

const STORAGE_KEY = 'i18n:pseudoloc:enabled'

export function PseudolocProvider({ children }: PropsWithChildren) {
  const [enabled, setEnabled] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  })

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const newValue = !prev
      try {
        sessionStorage.setItem(STORAGE_KEY, String(newValue))
      } catch {}
      return newValue
    })
  }, [])

  return (
    <PseudolocContext.Provider value={{ enabled, toggle }}>
      {children}
    </PseudolocContext.Provider>
  )
}

export function usePseudoloc(): PseudolocContextValue {
  const context = useContext(PseudolocContext)
  // Return default disabled state if context is not available (e.g., SSR)
  if (context === undefined) {
    return { enabled: false, toggle: () => {} }
  }
  return context
}
